import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';
import { ALIGN_TYPES, VALUE_TYPES as THVT } from "../../../configs/TableHeaderConstants";



const today = () => {
    return new Date().toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
}

export const InitialReceiptHeaderState = {
    voucher_no: null,
    fee_type: null,
    // invoice_header_id: null,
    school_id: null,
    receipt_date: new Date().toISOString().substr(0, 10),
    mode_of_pay_id: null,
    student_id: null,
    cheque_type: null,
    cheque_no: null,
    cheque_date: null,
    bank_detail_id: null,
    other_reference: null,
    credit_ledger_id: null,
    debit_ledger: "Bank- Rak Bank G1",
    transport_type_id: null,
    zone_id: null,
    area_id: null,
    debit_amount: null,
    academic_year_id: null,
    term_id: null,
    // voucher_type: null,
    // value_date: null,
    // credit_account_id: null,
};

export const ReceiptHeaderSchema = Yup.object().shape({
    voucher_no: Yup.string().nullable(),
    fee_type: Yup.string().required(),
    // invoice_header_id: Yup.number().required(),
    receipt_date: Yup.date().required(),
    school_id: Yup.number().required(),
    student_id: Yup.number().nullable(),
    mode_of_pay_id: Yup.number().required(),
    cheque_type: Yup.string().nullable(),
    cheque_no: Yup.string().nullable(),
    cheque_date: Yup.date().nullable(),
    bank_detail_id: Yup.string().nullable(),
    other_reference: Yup.string().nullable(),
    credit_ledger_id: Yup.number().nullable(),
    debit_ledger: Yup.string().nullable(),
    transport_type_id: Yup.number().nullable(),
    zone_id: Yup.number().nullable(),
    area_id: Yup.number().nullable(),
    debit_amount: Yup.number().nullable(),
    academic_year_id: Yup.number().nullable(),
    term_id: Yup.number().nullable(),
    // credit_account_id: Yup.number().nullable(),
    // value_date: Yup.date().nullable(),
    // voucher_type: Yup.string().nullable(),
});

export const ReceiptHeaderFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "voucher_no", title: "Voucher No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "receipt_date", title: "Receipt Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
    { name: "term_id", title: "Term", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "debit_ledger", title: "Debit Ledger", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "debit_amount", title: "Debit Amount", required: false, type: VALUE_TYPES.DECIAML, disabled: false },
    { name: "mode_of_pay_id", title: "Payment Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "cheque_no", title: "Cheque No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "cheque_type", title: "Cheque Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code", disabled: false },
    { name: "bank_detail_id", title: "Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "cheque_date", title: "Cheque Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: true },
    { name: "other_reference", title: "Other Reference", required: false, type: VALUE_TYPES.TEXT },
    { name: "student_id", title: "Student", required: false, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "credit_ledger_id", title: "Credit Ledger", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "student_id", title: "Parent Name", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "father_name", itemValue: "id", disabled: true },
    { name: "zone_id", title: "Zone", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "area_id", title: "Area", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "transport_type_id", title: "Transport Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "type", itemValue: "id", disabled: true },
    { name: "class_id", title: "Class", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
];

const InitialReceiptHeaderSTState = {
    school_id: null,
    fee_type: "School Transport",
    voucher_no: null,
    receipt_date: new Date().toISOString().substr(0, 10),
    academic_year_id: null,
    term_id: null,
    debit_ledger_id: null,
    debit_amount: null,
    mode_of_pay_id: null,
    cheque_no: null,
    cheque_type: null,
    bank_detail_id: null,
    cheque_date: null,
    other_reference: null,
    student_id: null,
    credit_ledger_id: null,
    zone_id: null,
    area_id: null,
    transport_type_id: null,
    class_id: null,
    outstanding_balance: null,
    receipt_status: true,
    months: []
};

const ReceiptHeaderSTSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    fee_type: Yup.string().required(),
    voucher_no: Yup.string().nullable(),
    receipt_date: Yup.date().required(),
    academic_year_id: Yup.number().required(),
    term_id: Yup.number().required(),
    debit_ledger_id: Yup.number().required(),
    debit_amount: Yup.number().nullable(),
    mode_of_pay_id: Yup.number().required(),
    cheque_no: Yup.string().nullable(),
    cheque_type: Yup.string().nullable(),
    bank_detail_id: Yup.number().nullable(),
    cheque_date: Yup.date().nullable(),
    other_reference: Yup.string().nullable(),
    student_id: Yup.number().required(),
    credit_ledger_id: Yup.number().required(),
    zone_id: Yup.number().nullable(),
    area_id: Yup.number().nullable(),
    transport_type_id: Yup.number().nullable(),
    class_id: Yup.number().nullable(),
    outstanding_balance: Yup.number().nullable(),
    receipt_status: Yup.boolean().required(),
    months: Yup.array().min(1).required()
});

const ReceiptHeaderSTFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "student_id", title: "Student ID", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "voucher_no", title: "Receipt No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "receipt_date", title: "Receipt Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id", disabled: true },
    { name: "term_id", title: "Term", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "months", title: "Months", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "month", itemValue: "id" },
    { name: "debit_ledger_id", title: "Bank", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "debit_amount", title: "Debit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "mode_of_pay_id", title: "Payment Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "cheque_no", title: "Chq No/Card No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "cheque_type", title: "Chq Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code", disabled: false },
    { name: "bank_detail_id", title: "Chq Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "cheque_date", title: "Chq Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: true },
    { name: "other_reference", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
    { name: "credit_ledger_id", title: "Credit Ledger", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "first_name", itemValue: "id", disabled: false },
    { name: "student_id", title: "Parent Name", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "father_name", itemValue: "id", disabled: true },
    { name: "zone_id", title: "Zone", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "area_id", title: "Area", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "transport_type_id", title: "Transport Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "type", itemValue: "id", disabled: true },
    { name: "class_id", title: "Class", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "outstanding_balance", title: "Outstanding Balance", required: false, type: VALUE_TYPES.NUMBER, disabled: true },
    { name: "receipt_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

const InitialReceiptHeaderOFState = {
    school_id: null,
    student_id: null,
    fee_type: "Other Fees",
    voucher_no: null,
    receipt_date: new Date().toISOString().substr(0, 10),
    academic_year_id: null,
    debit_ledger_id: null,
    debit_amount: 0,
    mode_of_pay_id: null,
    cheque_no: null,
    cheque_type: null,
    bank_detail_id: null,
    cheque_date: null,
    other_reference: null,
    invoice_header_id: null,
    receipt_status: true

};

const ReceiptHeaderOFSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    fee_type: Yup.string().required(),
    voucher_no: Yup.string().nullable(),
    receipt_date: Yup.date().required(),
    academic_year_id: Yup.number().required(),
    debit_ledger_id: Yup.number().required(),
    debit_amount: Yup.number().nullable(),
    mode_of_pay_id: Yup.number().required(),
    cheque_no: Yup.string().nullable(),
    cheque_type: Yup.string().nullable(),
    bank_detail_id: Yup.number().nullable(),
    cheque_date: Yup.date().nullable(),
    other_reference: Yup.string().nullable(),
    student_id: Yup.number().required(),
    invoice_header_id: Yup.number().nullable(),
    receipt_status: Yup.boolean().required()
});

const ReceiptHeaderOFFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "student_id", title: "Student ID", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code", itemValue: "id" },
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "invoice_header_id", title: "Invoice", required: false, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "invoice_no", itemValue: "id" },
    { name: "voucher_no", title: "Receipt No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "receipt_date", title: "Receipt Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "student_id", title: "Student Name", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id", disabled: false },
    { name: "student_id", title: "Parent Name", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "father_name", itemValue: "id", disabled: true },
    { name: "debit_ledger_id", title: "Debit Ledger", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "debit_amount", title: "Debit Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "mode_of_pay_id", title: "Payment Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "cheque_no", title: "Chq No/Card No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "cheque_type", title: "Chq Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code", disabled: false },
    { name: "bank_detail_id", title: "Chq Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "cheque_date", title: "Chq Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: true },
    { name: "other_reference", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
    { name: "receipt_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

const InitialReceiptHeaderAFState = {
    fee_type: "Account & Finance",
    voucher_no: null,
    receipt_date: new Date().toISOString().substr(0, 10),
    debit_ledger_id: null,
    debit_amount: 0,
    cheque_type: null,
    other_reference: null,
    receipt_status: true
};

const ReceiptHeaderAFSchema = Yup.object().shape({
    fee_type: Yup.string().required(),
    voucher_no: Yup.string().nullable(),
    receipt_date: Yup.date().required(),
    debit_ledger_id: Yup.number().required(),
    debit_amount: Yup.number().nullable(),
    cheque_type: Yup.string().nullable(),
    other_reference: Yup.string().nullable(),
    receipt_status: Yup.boolean().required()
});

const ReceiptHeaderAFFormFields = [
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "debit_ledger_id", title: "Debit Ledger", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "voucher_no", title: "Receipt No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "receipt_date", title: "Receipt Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "debit_amount", title: "Debit Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "cheque_type", title: "Chq Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code", disabled: false },
    { name: "other_reference", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
    { name: "receipt_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

const InitialReceiptHeaderPdcBankState = {
    fee_type: "PDC Bank Receipt",
    voucher_no: null,
    receipt_date: new Date().toISOString().substr(0, 10),
    debit_ledger_id: null,
    debit_amount: 0,
    other_reference: null,
    receipt_status: true
};

const ReceiptHeaderPdcBankSchema = Yup.object().shape({
    fee_type: Yup.string().required(),
    voucher_no: Yup.string().nullable(),
    receipt_date: Yup.date().required(),
    debit_ledger_id: Yup.number().required(),
    debit_amount: Yup.number().nullable(),
    other_reference: Yup.string().nullable(),
    receipt_status: Yup.boolean().required()
});

const ReceiptHeaderPdcBankFormFields = [
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code" },
    { name: "voucher_no", title: "Receipt Voucher (PDR) No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "receipt_date", title: "V Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "debit_ledger_id", title: "Through(Dr)", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "debit_amount", title: "Amount (Dr)", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "other_reference", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
    { name: "receipt_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

export const formConfig = {
    "School Transport": {
        "state": InitialReceiptHeaderSTState,
        "schema": ReceiptHeaderSTSchema,
        "formFields": ReceiptHeaderSTFormFields
    },
    "Other Fees": {
        "state": InitialReceiptHeaderOFState,
        "schema": ReceiptHeaderOFSchema,
        "formFields": ReceiptHeaderOFFormFields
    },
    "Account & Finance": {
        "state": InitialReceiptHeaderAFState,
        "schema": ReceiptHeaderAFSchema,
        "formFields": ReceiptHeaderAFFormFields
    },
    "PDC Bank Receipt": {
        "state": InitialReceiptHeaderPdcBankState,
        "schema": ReceiptHeaderPdcBankSchema,
        "formFields": ReceiptHeaderPdcBankFormFields
    }
}

export const InitialReceiptLineState = {
    narration: null,
    credit_amount: null,
    area_id: null,
    // vat_percentage: 0,
    vat_amount: 0,
    total_amount: 0,
    credit_ledger_id: null,
    cheque_date: null,
    cheque_no: null,
    mode_of_pay_id: null,
    bank_detail_id: null
};

export const ReceiptLineSchema = Yup.object().shape({
    narration: Yup.string().required(),
    credit_amount: Yup.number().required(),
    area_id: Yup.number().nullable(),
    // vat_percentage: Yup.number().nullable().min(0).max(100),
    vat_amount: Yup.number().nullable(),
    total_amount: Yup.number().required(),
    credit_ledger_id: Yup.number().nullable(),
    cheque_date: Yup.date().nullable(),
    cheque_no: Yup.string().nullable(),
    mode_of_pay_id: Yup.number().nullable(),
    bank_detail_id: Yup.number().nullable(),
});

export const ReceiptLineFormFields = [
    { name: "credit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code", itemValue: "id" },
    { name: "credit_ledger_id", title: "Credit Ledger", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "cheque_no", title: "Chq No/Ref", required: false, type: VALUE_TYPES.TEXT, disabled: false },
    { name: "cheque_date", title: "Chq Dt", required: false, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "bank_detail_id", title: "Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "mode_of_pay_id", title: "Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "credit_amount", title: "Credit Amt", required: true, type: VALUE_TYPES.DECIAML },
    // { name: "vat_percentage", title: "VAT %", required: false, type: VALUE_TYPES.DECIAML },
    { name: "vat_amount", title: "VAT Amount", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "total_amount", title: "Total Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
];

export const requiredFormFieldMapper = {
    "Cheque": ["cheque_type", "cheque_no", "cheque_date", "bank_detail_id"],
}

export const disabledFormFieldMapper = {
    "Cash": ["cheque_type", "cheque_no", "cheque_date", "bank_detail_id"],
}

export const notDisabled = ["cheque_type", "cheque_no", "cheque_date", "bank_detail_id"]

export const allReceiptHeaders = ["voucher_no", "fee_type", "receipt_date", "school_id", "student_id", "mode_of_pay_id", "cheque_type", "cheque_no", "cheque_date", "bank_detail_id", "other_reference", "credit_ledger_id", "debit_ledger", "transport_type_id", "zone_id", "area_id", "debit_amount", "academic_year_id", "term_id"];

export const showReceiptFields = {
    "School Transport": ["school_id", "fee_type", "voucher_no", "receipt_date", "academic_year_id", "term_id", "debit_ledger", "debit_amount", "mode_of_pay_id", "cheque_no", "cheque_type", "bank_detail_id", "cheque_date", "other_reference", "student_id", "credit_ledger_id", "zone_id", "area_id", "transport_type_id", "class_id"],
    "Other Fees": ["school_id", "fee_type", "voucher_no", "receipt_date", "student_id", "academic_year_id", "debit_ledger", "debit_amount", "mode_of_pay_id", "cheque_no", "cheque_type", "bank_detail_id", "cheque_date", "other_reference", "credit_ledger_id"],
    "Account & Finance": ["fee_type", "debit_ledger", "voucher_no", "receipt_date", "debit_amount", "cheque_type", "other_reference", "credit_ledger_id"]
};

export const showReceiptLineFields = {
    "School Transport": ["narration", "credit_amount", "total_amount"],
    "Other Fees": ["credit_ledger_id", "narration", "credit_amount", "vat_percentage", "total_amount"],
    "Account & Finance": ["credit_ledger_id", "cheque_no", "cheque_date", "bank_detail_id", "mode_of_pay_id", "narration", "credit_amount"]
};

const STReceiptLineState = {
    narration: null,
    credit_amount: null,
    total_amount: 0,
};

const STReceiptLineSchema = Yup.object().shape({
    narration: Yup.string().required(),
    credit_amount: Yup.number().required(),
    total_amount: Yup.number().required(),
});

const STReceiptLineFormFields = [
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "credit_amount", title: "Credit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "total_amount", title: "Total Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

const SCHOOL_TRANSPORT_LINE_TABLE_HEADS = [
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 700 },
    { id: 'credit_amount', label: 'Credit Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'total_amount', label: 'Total Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
]

export const OFReceiptLineState = {
    credit_ledger_id: null,
    narration: null,
    credit_amount: null,
    total_amount: 0,
};

export const OFReceiptLineSchema = Yup.object().shape({
    credit_ledger_id: Yup.number().required(),
    narration: Yup.string().required(),
    credit_amount: Yup.number().required(),
    total_amount: Yup.number().required(),
});

export const OFReceiptLineFormFields = [
    { name: "credit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "credit_amount", title: "Credit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "vat_amount", title: "Vat@5%", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "total_amount", title: "Total Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

const OTHER_FEES_LINE_TABLE_HEADS = [
    { id: 'account_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 150 },
    { id: 'credit_ledger', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 250 },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 500 },
    { id: 'credit_amount', label: 'Amt AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'vat_amount', label: 'Vat@5%', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'total_amount', label: 'Total Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
]

const AFReceiptLineState = {
    credit_ledger_id: null,
    cheque_no: null,
    cheque_date: null,
    bank_detail_id: null,
    mode_of_pay_id: null,
    narration: null,
    credit_amount: null,
};

const AFReceiptLineSchema = Yup.object().shape({
    credit_ledger_id: Yup.number().required(),
    cheque_no: Yup.string().nullable(),
    cheque_date: Yup.date().nullable(),
    bank_detail_id: Yup.number().nullable(),
    mode_of_pay_id: Yup.number().required(),
    narration: Yup.string().required(),
    credit_amount: Yup.number().required()
});

const AFReceiptLineFormFields = [
    { name: "credit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "cheque_no", title: "Chq No/Ref", required: false, type: VALUE_TYPES.TEXT, disabled: false },
    { name: "cheque_date", title: "Chq Dt", required: false, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "bank_detail_id", title: "Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "mode_of_pay_id", title: "Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "credit_amount", title: "Credit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },

];

const ACCOUNT_AND_FINANACE_LINE_TABLE_HEADS = [
    { id: 'account_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'credit_ledger', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_no', label: 'Chq No/Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_date', label: 'Chq Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'bank_detail', label: 'Bank', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'mode_of_pay', label: 'Mode', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'credit_amount', label: 'Credit Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER }
]

const PdcBankReceiptLineState = {
    credit_ledger_id: null,
    cheque_no: null,
    cheque_date: null,
    bank_detail_id: null,
    narration: null,
    credit_amount: null,
};

const PdcBankReceiptLineSchema = Yup.object().shape({
    credit_ledger_id: Yup.number().required(),
    cheque_no: Yup.string().nullable(),
    cheque_date: Yup.date().nullable(),
    bank_detail_id: Yup.number().nullable(),
    narration: Yup.string().required(),
    credit_amount: Yup.number().required()
});

const PdcBankReceiptLineFormFields = [
    { name: "credit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "cheque_no", title: "Chq No/Ref", required: false, type: VALUE_TYPES.TEXT, disabled: false },
    { name: "cheque_date", title: "Chq Dt", required: false, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "bank_detail_id", title: "Bank", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bank_name", itemValue: "id" },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "credit_amount", title: "Credit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },

];

const PDC_BANK_RECEIPT_LINE_TABLE_HEADS = [
    { id: 'credit_ledger', label: 'Account Name (Cr)', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'account_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_no', label: 'Chq No/Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_date', label: 'Chq Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'bank_detail', label: 'Bank', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'credit_amount', label: 'Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'icon_btns', label: 'Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["delete"] },
]

export const receiptTypes = {
    "School Transport": {
        "state": STReceiptLineState,
        "schema": STReceiptLineSchema,
        "formFields": STReceiptLineFormFields,
        "tableHeaders": SCHOOL_TRANSPORT_LINE_TABLE_HEADS
    },
    "Other Fees": {
        "state": OFReceiptLineState,
        "schema": OFReceiptLineSchema,
        "formFields": OFReceiptLineFormFields,
        "tableHeaders": OTHER_FEES_LINE_TABLE_HEADS
    },
    "Account & Finance": {
        "state": AFReceiptLineState,
        "schema": AFReceiptLineSchema,
        "formFields": AFReceiptLineFormFields,
        "tableHeaders": ACCOUNT_AND_FINANACE_LINE_TABLE_HEADS
    },
    "PDC Bank Receipt": {
        "state": PdcBankReceiptLineState,
        "schema": PdcBankReceiptLineSchema,
        "formFields": PdcBankReceiptLineFormFields,
        "tableHeaders": PDC_BANK_RECEIPT_LINE_TABLE_HEADS
    }
}

const filterState = {
    fee_types: null,
    schools: null,
    students: null,
    receipt_from_date: null,
    receipt_to_date: null,
    status: null,
};
const filterSchema = Yup.object().shape({
    fee_types: Yup.array().nullable(),
    schools: Yup.array().nullable(),
    students: Yup.array().nullable(),
    receipt_from_date: Yup.date().nullable(),
    receipt_to_date: Yup.date().nullable(),
    status: Yup.string().nullable(),
});

const filterFormFields: any[] = [
    { name: "fee_types", title: "Fee Types", required: false, type: VALUE_TYPES.MULTISELECT, options: [{ name: "School Transport" }, { name: "Other Fees" }, { name: "Account & Finance" }, { name: "PDC Bank Receipt" }], apiRequired: true, displayKey: "name", itemValue: "name" },
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "students", title: "Students", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "receipt_from_date", title: "Receipt From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "receipt_to_date", title: "Receipt To Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "status", title: "Status", required: false, type: VALUE_TYPES.SELECT, options: [{ name: "Active" }, { name: "In-Active" }], apiRequired: true, displayKey: "name", itemValue: "name" },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}

export const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" }
]